<!-- 公告栏组件 -->
<template>
    <div class="message" ref="msgBox" id="message" v-if="!noticeFlag">
        <marquee behavior="scroll" direction="left" ref="notice" scrollamount="6" onmouseover="this.stop()"
            onmouseout="this.start()">
            <span class="msg" ref="scrollMsg">
                <span class="title">
                    <svg-icon icon-class="topNotice"></svg-icon>
                    公告 :
                </span>
                <span class="content" v-html="notice.msg"></span>
                <span class="closeBtn" @click="closeMsg">
                    关闭 <i class="el-icon-close"></i>
                </span>
            </span>
        </marquee>
    </div>
</template>

<script>
import { getTopNotice } from '@/api/notice'

export default {
    name: 'NoticeBar',

    data() {
        return {
            noticeFlag: true,
            notice: {
                id: null,
                msg: ''
            }
        }
    },
    mounted() {
        this.loadTopNotice()
    },

    methods: {
        /**
         * 加载顶部公告
         */
        loadTopNotice() {
            const noticeId = sessionStorage.getItem("notice")
            getTopNotice().then(res => {
                if (res.code === 200 && res.data) {
                    this.notice.id = res.data.id
                    this.notice.msg = res.data.content
                    if (noticeId != this.notice.id) {
                        this.noticeFlag = false
                    }
                }
            }).catch(err => {
                console.error('获取公告失败:', err)
            })
        },

        /**
         * 关闭公告
         */
        closeMsg() {
            sessionStorage.setItem("notice", this.notice.id)
            var message = document.getElementById("message");
            message.style.opacity = 0;
            setTimeout(function () {
                message.style.display = "none";
            }, 500);
        },

        /**
         * 停止滚动
         */
        stop() {
            let notice = this.$refs.notice
            clearInterval(notice.mysetInterval)
        },

        /**
         * 开始滚动
         */
        start() {
            let notice = this.$refs.notice
            notice.run()
        },

    }
}
</script>
<style scoped lang='scss'>
.message {
    width: 100%;
    overflow: hidden;
    position: relative;
    height: 30px;
    line-height: 30px;
    color: var(--text-color1);
    top: 60px;
    transition: all 0.5s linear;

    .msg {
        line-height: 30px;
        font-size: 14px;
        font-weight: 700;
        // position: absolute;

        .title {

            margin-right: 15px;

            svg {
                width: 20px;
                height: 20px;
                vertical-align: -5px;
            }
        }

        .content {
            ::v-deep a {
                text-decoration: none;
                color: red;
            }
        }

        .closeBtn {
            margin-left: 15px;
            font-weight: 400;
            cursor: pointer;
        }
    }
}
</style>


